import React from "react";
import BaseStepComponent from "./common/BaseStepComponent";

const Step5 = () => {
  return (
    <BaseStepComponent
      stepNumber={5}
      title="Live Calls"
      videoSrc="https://contentmedius.s3.ap-south-1.amazonaws.com/part_5_live_calls_rtp_ptp.mp4"
      directLink="https://contentmedius.s3.ap-south-1.amazonaws.com/part_5_live_calls_rtp_ptp.mp4"
      nextStep={6} // Next step will be 6, which is the first call audit step (Kreditbee)
    />
  );
};

export default Step5; 